import React, { useEffect } from "react";
import logo from "./logo.svg";
import Layout, { CAPABILITIES_LOOKUP, TAB_LOOKUP } from "./Layout";
import image from "./images/virtual-coworkers.jpg";
import ArrowButton from "./ArrowButton";
import Lottie from "react-lottie";
// If there are images, use the converted json (index.js)
import animationData from "./lottie/storyboard11";
// If there are NO images, just load the json directly
// import animationData from "./lottie/storyboard7/data.json";
import "./Capabilities8ProactiveOutreachScreen.scss";
import { t } from "i18next";

function Capabilities8_5AINoiseRemovalScreen() {
  useEffect(() => {
    const script = document.createElement("script");

    script.src = "https://play.vidyard.com/embed/v4.js";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  });
  return (
    <div className="capabilities-screen fill-absolute">
      <div className="container full-height row">
        <div className="challenges-image full-height padding flex vertical-center mobile-nav-padding">
          {/* <Lottie
            options={{
              animationData,
            }}
            // height="80%"
            // width="90%"
          /> */}
          <div
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
            }}
          >
            <div
              className="stream-video-wrapper"
              style={{ width: "100%", minWidth: 300 }}
            >
              <img
                className="vidyard-player-embed"
                style={{ width: "100%", minWidth: 300 }}
                src="https://play.vidyard.com/o4BzmA7X43bGvw9vGRh19f.jpg"
                data-uuid="o4BzmA7X43bGvw9vGRh19f"
                data-v="4"
                data-type="inline"
                alt="Eliminate Distractions from the Conversation with AI Noise Removal"
              />
            </div>
          </div>
        </div>
        <div
          className="full-height padding flex vertical-center"
          // style={{ maxWidth: "50%" }}
        >
          <h2 className="green-header">{t("Capability8_5.title")}</h2>
          <p>{t("Capability8_5.section1")}</p>
          <p>{t("Capability8_5.section2")}</p>
          <p>{t("Capability8_5.section3")}</p>
        </div>
      </div>
      <div className="buttons-container">
        <ArrowButton to="/capabilities-outreach" side="left"></ArrowButton>
        <ArrowButton
          to="/capabilities-collaboration"
          side="right"
        ></ArrowButton>
      </div>
    </div>
  );
}

export default Capabilities8_5AINoiseRemovalScreen;
